import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52da5374"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "location" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("span", null, "我的地址")
], -1))
const _hoisted_3 = {
  key: 1,
  class: "text"
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "已保存的收货地址(最多3个)", -1))
const _hoisted_6 = { class: "tab" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fff","font-size":"14px","display":"inline-block","background-color":"#2655ae","padding":"10px 20px","border-radius":"20px"} }, "默认地址", -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加收货地址", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Lack = _resolveComponent("Lack")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Title = _resolveComponent("Title")!
  const _component_AddressFrom = _resolveComponent("AddressFrom")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.addressList.data.length <= 0 && !_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Lack, {
          key: 0,
          "onSetDialogVisible()": _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDialogVisible()))
        }))
      : _createCommentVNode("", true),
    (_ctx.addressList.data.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setDialogVisible())),
              style: {"cursor":"pointer"}
            }, " +新增收货地址 ")
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.addressList.data.length > 0)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  data: _ctx.addressList.data,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "contacts",
                      label: "收货人"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "location",
                      label: "收货地址",
                      width: "430px"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.province) + " " + _toDisplayString(scope.row.city) + " " + _toDisplayString(scope.row.area) + " " + _toDisplayString(scope.row.address), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "phonenumber",
                      label: "联系电话"
                    }),
                    _createVNode(_component_el_table_column, { label: "操作" }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", {
                          class: "edit-address",
                          style: {"font-size":"14px","padding-right":"5px","cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.updateAddress(scope.row))
                        }, "编辑", 8, _hoisted_7),
                        _createElementVNode("span", {
                          style: {"font-size":"14px","padding-left":"5px","cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.delAddress(scope.$index))
                        }, "删除", 8, _hoisted_8)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      class: "set-default",
                      prop: "default"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.default == 1)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              link: "",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              link: "",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  style: {"border-bottom":"1px solid #2655ae","color":"#2655ae","font-size":"14px","display":"inline-block","margin":"10px 20px"},
                                  onClick: ($event: any) => (_ctx.setDefaultAddress(scope.$index))
                                }, "设为默认", 8, _hoisted_10)
                              ]),
                              _: 2
                            }, 1024))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]))
              : _createCommentVNode("", true)
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      ref: "sonRef",
      dialogwidth: "625px",
      addressItems: _ctx.addressItem
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#F2F5FA"
        }, {
          title: _withCtx(() => [
            _hoisted_11
          ]),
          edit: _withCtx(() => [
            _createElementVNode("i", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mclose())),
              class: "icon iconfont icon-shanchu",
              style: {"font-size":"12px"}
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(({ addressItems }) => [
        _createVNode(_component_AddressFrom, {
          onMclose: _ctx.mclose,
          addressItem: addressItems
        }, null, 8, ["onMclose", "addressItem"])
      ]),
      _: 1
    }, 8, ["addressItems"])
  ]))
}